import makeApi from 'libs/core/configureAxios'

const api = makeApi(`${process.env.REACT_APP_API_BASE_URL}`)

const getCourseTemplateLabels = payload => api.get('/platform/course-temps/labels', payload)

const deleteCourseTemplateLabel = payload =>
  api.delete(`/platform/course-temps/labels/${payload.labelId}`, { params: payload.params })

const deleteCourseTemplateFromLabel = payload =>
  api.delete(`/platform/course-temps/${payload.labelId}/${payload.courseTempId}`, {
    params: payload.params,
  })

const getCourseTemplates = payload => api.get('/platform/course-temps', payload)

const getCourseTemplatesAddable = payload => api.get('/platform/course-temps/addable', payload)

const getCourseTemplateById = payload =>
  api.get(`/platform/course-temp/${payload.courseTempId}`, payload)

const getCourseTemplateUpUrl = payload => api.get(`/platform/course-temp/upload-url`, payload)

const createCourseTemplateLabel = payload =>
  api.post(`/platform/course-temps/labels`, payload.data, { params: payload.params })

const editCourseTemplateLabel = payload =>
  api.put(`/platform/course-temps/labels/${payload.labelId}`, payload.data, {
    params: payload.params,
  })

const editCourseTemplate = payload =>
  api.put(`/platform/course-temps`, payload.data, {
    params: payload.params,
  })

const editCourseTemplateLabelsById = payload =>
  api.put(`/platform/course-temps/${payload.courseTempId}/label-ref`, payload.data, {
    params: payload.params,
  })

const editCourseTemplateLabelVideosById = payload =>
  api.put(`/platform/course-temps/labels/${payload.labelId}/course-ref`, payload.data, {
    params: payload.params,
  })

const createCourseTemplate = payload =>
  api.post(`/platform/course-temp`, payload.data, { params: payload.params })

const addCourseTemplateProgram = payload =>
  api.post(`/platform/courseTemp/course-program/${payload.courseTempId}`, payload.data, {
    params: payload.params,
  })

export default {
  getCourseTemplateLabels,
  getCourseTemplatesAddable,
  deleteCourseTemplateLabel,
  deleteCourseTemplateFromLabel,
  getCourseTemplates,
  getCourseTemplateById,
  getCourseTemplateUpUrl,
  createCourseTemplateLabel,
  editCourseTemplate,
  editCourseTemplateLabel,
  editCourseTemplateLabelsById,
  editCourseTemplateLabelVideosById,
  createCourseTemplate,
  addCourseTemplateProgram,
}
